import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import {  FaChevronRight } from 'react-icons/fa';
import { FaHome, FaClipboardList, FaWallet, FaChartLine, FaBell, FaExchangeAlt, FaCog, FaShoppingBasket } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const RestaurantSettings = () => {
  return (
    <Box p={4}>
    {/* Main Content */}
    <Box bg="white" p={4} borderRadius="md" boxShadow="md" w={["100%", "100%", "80%"]} mx="auto">
    {/* Update Profile */}
    <Box p={4} borderBottom="1px solid" borderColor="gray.200">
    <Flex alignItems="center" justify="space-between">
        <Text fontSize="md" fontWeight="semibold">
        Update Profile
        </Text>
        <FaChevronRight />
    </Flex>
    </Box>

    {/* Menu */}
    <Box p={4} borderBottom="1px solid" borderColor="gray.200">
    <Flex alignItems="center" justify="space-between">
        <Text fontSize="md" fontWeight="semibold">
         Our Menu
        </Text>
        <FaChevronRight />
    </Flex>
    </Box>

    {/* Change Password */}
    <Box p={4} borderBottom="1px solid" borderColor="gray.200">
    <Flex alignItems="center" justify="space-between">
        <Text fontSize="md" fontWeight="semibold">
        Change Password
        </Text>
        <FaChevronRight />
    </Flex>
    </Box>

    {/* Change Pin */}
    <Box p={4} borderBottom="1px solid" borderColor="gray.200">
    <Flex alignItems="center" justify="space-between">
        <Text fontSize="md" fontWeight="semibold">
        Change Pin
        </Text>
        <FaChevronRight />
    </Flex>
    </Box>

    {/* Settings */}
    <Box p={4} borderBottom="1px solid" borderColor="gray.200">
    <Flex alignItems="center" justify="space-between">
        <Text fontSize="md" fontWeight="semibold">
         Restaurant Settings
        </Text>
        <FaChevronRight />
    </Flex>
    </Box>

    {/* Contact Support */}
    <Box p={4} borderBottom="1px solid" borderColor="gray.200">
    <Flex alignItems="center" justify="space-between">
        <Text fontSize="md" fontWeight="semibold">
        Contact Support
        </Text>
        <FaChevronRight />
    </Flex>
    </Box>

    {/* Sign Out */}
    <Box p={4}>
    <Flex alignItems="center" justify="space-between">
        <Text fontSize="md" fontWeight="semibold">
        Sign Out
        </Text>
        <FaChevronRight />
    </Flex>
    </Box>

  </Box>
        {/* Bottom Navigation for Mobile */}
        <Flex
          bg="blue.200"
          p={2}
          mt={4}
          align="center"
          justify="space-between"
          position="fixed"
          bottom={0}
          mx="auto"
          width="95%"
          display={{ base: 'flex', md: 'none' }} // Hide on larger screens
        >
            <Box textAlign="center" flex="1" p={2}>
              <Link to="restaurant">
                  <Flex alignItems="center" flexDirection="column">
                  <FaHome />
                  <Text color="white" fontSize="xs" mt={1}>
                      Home
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-orders">
                  <Flex alignItems="center" flexDirection="column">
                  <FaClipboardList />
                  <Text color="white" fontSize="xs" mt={1}>
                      Orders
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-market-place">
                  <Flex alignItems="center" flexDirection="column">
                  <FaShoppingBasket />
                  <Text color="white" fontSize="xs" mt={1}>
                      Market
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/restaurant-analytics">
                <Flex alignItems="center" flexDirection="column">
                <FaChartLine />
                <Text color="white" fontSize="xs" mt={1}>
                    Analytics
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-wallet">
                  <Flex alignItems="center" flexDirection="column">
                  <FaWallet />
                  <Text color="white" fontSize="xs" mt={1}>
                      Wallet
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-trades">
                  <Flex alignItems="center" flexDirection="column">
                  <FaExchangeAlt />
                  <Text color="white" fontSize="xs" mt={1}>
                      Trades
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-notifications">
                  <Flex alignItems="center" flexDirection="column">
                  <FaBell />
                  <Text color="white" fontSize="xs" mt={1}>
                      Notifications
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-settings">
                  <Flex alignItems="center" flexDirection="column">
                  <FaCog />
                  <Text color="white" fontSize="xs" mt={1}>
                      Settings
                  </Text>
                  </Flex>
              </Link>
            </Box>   
        </Flex>
        
  </Box>
);
};

export default RestaurantSettings;
